import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventsService } from '../../../../shared/services/utils/events.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastData } from '../../../../shared/models/b2b/toastData';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.css'],
})
export class ToastComponent implements OnInit, OnDestroy {
    isVisible = false;
    hide = false;
    toastData: ToastData = null;
    destroyed = new Subject<void>();

    constructor(private eventsService: EventsService) {}

    ngOnInit() {
        this.subscribeShowToast();
        this.subscribeHideToast();
    }

    subscribeShowToast() {
        this.eventsService
            .on<ToastData>('showToast')
            .pipe(takeUntil(this.destroyed))
            .subscribe((data) => {
                if (data) {
                    this.toastData = data;
                    this.isVisible = true;
                    this.hideAtTime();
                }
            });
    }

    subscribeHideToast() {
        this.eventsService
            .on<ToastData>('hideToast')
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => {
                this.hideAtTime();
            });
    }

    private hideAtTime() {
        setTimeout(() => {
            this.hide = true;
            // lo escondo cuando acaba la animación
            setTimeout(() => {
                this.isVisible = false;
            }, 300);
        }, this.toastData.duration);
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
